import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../config";

export const getOfficeImages = createAsyncThunk(
  "office/getAll",
  async () => {
    const response = await fetch(`${config.apiBaseUrl}/user-office-show`, {
      method: "GET",
    });

    const result = await response.json();
    console.log(result);
    return result; 
  }
);

const officeSlice = createSlice({
  name: "office",
  initialState: {
    images: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOfficeImages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOfficeImages.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.images = action.payload;
        
      })
      .addCase(getOfficeImages.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
  },
});

export default officeSlice.reducer;
